import UserRecharge from 'Components/UserRecharge/UserRecharge'
import React from 'react'

const Recharge = () => {
  return (
    <UserRecharge />
  )
}

export default Recharge